module.exports = __webpack_public_path__ + "img/19.67687563.png";